export default "/7ee56fc642439642e071ad6692a1a8b95a874bf4/a2cdf02300b2663230f496dbfe02b4a0.svg";